import { useEffect, useState } from "react";
import { Search, MapPin } from "lucide-react";
import { geocode } from "../../lib/geo";

export default function CityPicker({ onSelect, placeholder = "Search a city…", autoFocus = false }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (q.trim().length < 2) { setResults([]); return; }
    setLoading(true);
    const t = setTimeout(async () => {
      try { setResults(await geocode(q)); } catch { setResults([]); }
      finally { setLoading(false); }
    }, 300);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div data-testid="city-picker">
      <div className="relative">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input value={q} onChange={(e) => setQ(e.target.value)} autoFocus={autoFocus} data-testid="city-picker-input"
          placeholder={placeholder} className="w-full border border-zinc-300 pl-9 pr-3 py-2.5 outline-none focus:ring-2 focus:ring-primary text-base" />
      </div>
      {loading && <div className="text-xs text-muted-foreground mt-1">Searching…</div>}
      {results.length > 0 && (
        <div className="mt-2 border border-zinc-300 bg-white divide-y divide-zinc-100 max-h-60 overflow-auto">
          {results.map((r, i) => (
            <button key={i} onClick={() => { onSelect(r); setQ(""); setResults([]); }} data-testid={`city-option-${i}`}
              className="w-full flex items-center gap-2 px-3 py-2.5 text-left text-sm hover:bg-zinc-50">
              <MapPin className="w-4 h-4 text-primary shrink-0" />
              <span className="truncate">{r.name}{r.admin1 ? `, ${r.admin1}` : ""} · <span className="text-muted-foreground">{r.country}</span></span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
